module.exports = __webpack_public_path__ + "static/media/36.d3ffd211.jpg";